import { Injectable } from '@angular/core';
import { getKDWBaseUrl } from '../helpers/kdw-base-url.helper';
import { OktaHttpReqService } from './okta-http-req.service';

@Injectable()
export class CtxTypeService {
  constructor(private okatHttpReqService: OktaHttpReqService) {}

  getCtxTypes(params) {
    const url = `${getKDWBaseUrl()}/api/v1/contextual/types`;
    return this.okatHttpReqService.request('get', url, {params});
  }
}
